import { SxProps } from '@mui/material';

import { useDashboardController } from 'api/controllers/DashboardController';

import { useTranslations } from 'context/TranslationContext';

import { RevenueDashboardGrid } from './RevenueDashboardGrid';

interface OutstandingRevenueProps {
  isOnAllCompanies: boolean;
  sx?: SxProps;
}

export const OutstandingRevenue = ({
  sx,
  isOnAllCompanies
}: OutstandingRevenueProps) => {
  const { translate } = useTranslations();
  const { getOutstandingRevenue } = useDashboardController();

  return (
    <RevenueDashboardGrid
      sx={sx}
      isOnAllCompanies={isOnAllCompanies}
      callToApi={getOutstandingRevenue}
      gridTitle={translate('labels.outstandingRevenue')}
      noDataMessage={translate('labels.noOutstandingRevenueDataAvailable')}
    />
  );
};
